export default function (action, params = {}) {
	const attributes = {
		class: ['action', 'action--link'],
		href: this.url.getUrl(action.url, params)
	};
	return this.render('button', action, attributes);
}
